module.exports = __webpack_public_path__ + "static/img/commerce.a76a922b.jpg";